import React, { Fragment, memo } from 'react'
import { Form, Input } from 'antd'
import { LockOutlined } from '@ant-design/icons'

const ConfirmPassword: React.FC = () => {
  
  return (<Fragment>
    <Form.Item
      label='密码'
      name='password'
      rules={ [
        { required: true, message: '请输入密码' },
        {
          validator (_, value) {
            const pwdRegex = new RegExp('(?=.*[0-9])(?=.*[a-zA-Z]).{8,16}')
            if (!value || pwdRegex.test(value)) {
              return Promise.resolve()
            }
            return Promise.reject(new Error('密码为字母+数字组合且不能少于8位！'))
          },
        },
      ] }
    >
      <Input.Password
        placeholder='请输入'
        prefix={ <LockOutlined /> }
        autoComplete='new-password'
      />
    </Form.Item>
    <Form.Item
      label='确认密码'
      name='passwordConfirm'
      rules={ [
        { required: true, message: '请输入确认密码' },
        ({ getFieldValue }) => ({
          validator (_, value) {
            if (!value || getFieldValue('password') === value) {
              return Promise.resolve()
            }
            return Promise.reject(new Error('两次输入的密码不一致'))
          },
        }),
      ] }
    >
      <Input.Password
        placeholder='请输入'
        prefix={ <LockOutlined /> }
        autoComplete='new-password'
      />
    </Form.Item>
  </Fragment>)
}

export default memo(ConfirmPassword)
